module.exports = __webpack_public_path__ + "img/img5849.9bec76da.jpg";